import React, { CSSProperties, ReactNode } from "react";
import styled from "styled-components";
import { getNewLookTokens, newLookType } from "common/NewLook/tokens.ts";

interface PanelEmptyProps {
  title: ReactNode;
  /** One short line under the title. */
  description?: ReactNode;
  /** At most one action (a button or a link). */
  action?: ReactNode;
  className?: string;
  style?: CSSProperties;
  "data-testid"?: string;
}

/**
 * The new look's empty state inside a panel: a short title, one quiet line
 * and at most one action. No illustration; the panel title already says what
 * is missing.
 */
const PanelEmpty = ({
  title,
  description,
  action,
  className,
  style,
  "data-testid": testId,
}: PanelEmptyProps) => (
  <Wrapper className={className} style={style} data-testid={testId}>
    <Title>{title}</Title>
    {description && <Description>{description}</Description>}
    {action && <Action>{action}</Action>}
  </Wrapper>
);

export default PanelEmpty;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 32px 20px;
  text-align: center;
`;
const Title = styled.div`
  ${newLookType.panelTitle};
  color: ${(p) => getNewLookTokens(p.theme).ink};
`;
const Description = styled.div`
  max-width: 400px;
  ${newLookType.meta};
  color: ${(p) => getNewLookTokens(p.theme).muted};
`;
const Action = styled.div`
  margin-top: 12px;
`;
